import { Component, OnInit } from '@angular/core';
import { LoopBackAuth, ActivationApi, LoopBackConfig } from '../../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { BasicList } from '../../../../classes';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';
import { USER_ROLES, ORDER_STATUS, PAYMENT_TYPE } from '../../../../enums';
import { ProductsService } from '../../../../services';
import { Event } from '../../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-activation-list',
  templateUrl: './activation-list.component.html',
  styleUrls: ['./activation-list.component.css']
})
export class ActivationListComponent extends BasicList {
  host:string = LoopBackConfig.getPath();
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  ORDER_STATUS: typeof ORDER_STATUS = ORDER_STATUS;
  PAYMENT_TYPE: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  constructor(
    private activationApi: ActivationApi,
    private modalService: BsModalService,
    private loopBackAuth: LoopBackAuth,
    private hasRolePipe: HasRolePipe,
    private productService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    this.params = {
      where: {
        userId: !this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.ADMIN) ? this.getUser().id : undefined
      },
      order: 'dateCreated DESC'
    };
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'referenceNumber', placeholder: 'Card Reference Number', exact: true },
        { name: 'partnerId', placeholder: 'Partner id', exact: true },
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
      ],
      filters: {}
    }
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.activationApi.search.bind(this.activationApi)
      },
      delete: {
        method: this.activationApi.deleteById.bind(this.activationApi),
        deleteText: 'Proceed',
        title: 'Undo Activation'
      },
      ModalService: modalService
    };
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'delete:success':
        this.toast.success('Undo activation successful', 'Undo Activation');
      case 'initialized':
      case 'createModal:completed':
      case 'editModal:completed':
        this.getList();
      break;
      default:
        break;
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
